import blog from "./assets/blog.png"
import ecom from "./assets/ecom.png"
import icon from "./assets/blogIcon.jpg"
import notice from "./assets/notice-board.png"
import hotel from "./assets/hotel.png"
import spotify from "./assets/spotify.png"

// import blog from "./../../assets/blog.png"
// import ecom from "./../../assets/ecom.png"

export const featuredPortfolio = [
    {
        id: "1",
        title: "Blog App",
        img: `${blog}`,
        desc: "MERN application having functionality of any basic blogging site.",
        icon: `${icon}`
    },
    {
        id: "2",
        title: "E Commerce",
        img: `${ecom}`,
        desc: "E-commerce platform created usong ReactJS and Stripe.",
        icon: `${icon}`
    },
    {
        id: "3",
        title: "Online Notice Board",
        img: `${notice}`,
        desc: "Online Notice System by which school/college can notify their students about any notice",
        icon: `${icon}`
    },
    {
        id: "4",
        title: "Hotel Management",
        img: `${hotel}`,
        desc: "An application for both user's and Hotel to book room online or desktop.",
        icon: `${icon}`
    },
]

export const reactPortfolio = [
    {
        id: "1",
        title: "Blog-App",
        img: `${blog}`,
        desc: "Blog app created using mern. It has many functionality and can be used as anyregular blogging platform",
        icon: `${icon}`
    },
    {
        id: "2",
        title: "E-Commerce-App",
        img: `${ecom}`,
        desc: "E-commerce platform created usong ReactJS and Stripe.",
        icon: `${icon}`
    },
]

export const otherPortfolio = [
    {
        id: "1",
        title: "Blog-App",
        img: `${blog}`,
        desc: "Blog app created using mern. It has many functionality and can be used as anyregular blogging platform",
        icon: `${icon}`
    },
    {
        id: "2",
        title: "E-Commerce-App",
        img: `${ecom}`,
        desc: "E-commerce platform created usong ReactJS and Stripe.",
        icon: `${icon}`
    },
    {
        id: "3",
        title: "Online Notice Board",
        img: `${notice}`,
        desc: "Blog app created using mern. It has many functionality and can be used as anyregular blogging platform",
        icon: `${icon}`
    },
    {
        id: "4",
        title: "Spotify",
        img: `${spotify}`,
        desc: "Blog app created using mern. It has many functionality and can be used as anyregular blogging platform",
        icon: `${icon}`
    }
]